import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Button = ({ children, className, type, disabled, onClick }) => {
  const classNameRoot = classNames(
    'Button',
    { 'Button--disabled': disabled },
    className,
  );
  return (
    <button
      type={type}
      className={classNameRoot}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  className: null,
  type: 'button',
  disabled: false,
  onClick: null,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Form/Button/index.js